var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { DomSanitizer } from '@angular/platform-browser';
import { CropperSettings } from 'ngx-img-cropper';
import { config } from '../../config/config';
import { VisitorDataCache } from '../stores/visitor.calendar.store';
import { ConfigService } from './config.service';
var ImageService = /** @class */ (function () {
    function ImageService(domSanitizer) {
        this.domSanitizer = domSanitizer;
        // need to check why this config is not merged on production server
        this.prodPrefix = config.serverDomain; //'https://imgoingcalendar.com/';
        //ConfigService.config.assetImageServeUrl = 'https://imgoingcalendar.com/';
    }
    ImageService.prototype.safeImage = function (url) {
        return this.domSanitizer.bypassSecurityTrustUrl(url);
    };
    ImageService.prototype.safeUrl = function (url) {
        return this.domSanitizer.bypassSecurityTrustResourceUrl(url);
    };
    ImageService.prototype.imageSource = function (item) {
        if (!item) {
            return VisitorDataCache.logo || this.prodPrefix + config.defaultImageUrl;
        }
        var source = item.cover && item.cover.source;
        if (!source) {
            return VisitorDataCache.logo || this.prodPrefix + config.defaultImageUrl;
        }
        if (item.cover.source.startsWith('assets/imgs/')) {
            //if (item.cover.isDefault) {
            return this.prodPrefix + item.cover.source;
        }
        if (item.cover.source.startsWith('data:')) {
            return item.cover.source;
        }
        // if (item.isManuallyCreated || item.isFacebookEvent || item.isPromotionImage) {
        if (!item.cover.source.startsWith('http')) {
            return ConfigService.config.imageServeUrl + item.cover.source;
            //return 'https://api.imgoingcalendar.com/imgs/' + item.cover.source;
        }
        return item.cover.source;
    };
    ImageService.prototype.imageSourceUrl = function (imageUrl, useLogoIfNoImage) {
        if (useLogoIfNoImage === void 0) { useLogoIfNoImage = true; }
        if (!imageUrl) {
            if (useLogoIfNoImage) {
                return VisitorDataCache.logo || this.prodPrefix + config.defaultImageUrl;
            }
            return this.prodPrefix + config.defaultImageUrl;
        }
        if (imageUrl.indexOf(config.defaultImageDirectory) >= 0 && !imageUrl.startsWith('http')) {
            return this.prodPrefix + imageUrl;
        }
        if (imageUrl.startsWith('data:')) {
            return imageUrl;
        }
        if (imageUrl.startsWith('assets/imgs/')) {
            return this.prodPrefix + imageUrl;
        }
        if (!imageUrl.startsWith('http')) {
            return ConfigService.config.imageServeUrl + imageUrl;
            //return 'https://api.imgoingcalendar.com/imgs/' + imageUrl;
        }
        return imageUrl;
    };
    ImageService.prototype.isImUploadedImage = function (img) {
        //return img.indexOf(ConfigService.config.imageServeUrl) !== -1;
        return (img.indexOf('localhost:3000') !== -1 ||
            img.indexOf('imgoing-prod-api.xyz') !== -1 ||
            img.indexOf('api.imgoingcalendar.com') !== -1 ||
            img.indexOf('imgoing-dev-api.tk') !== -1 ||
            img.startsWith('data:'));
    };
    ImageService.prototype.getBase64ByImageFile = function (imageFile) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (imageFile) {
                try {
                    var image_1 = new Image();
                    var FR = new FileReader();
                    var canvas_1 = document.createElement('canvas');
                    var context_1 = canvas_1.getContext('2d');
                    FR.addEventListener('load', function (e) {
                        image_1.src = e.target.result;
                        //resolve((e as any).target.result);
                    });
                    FR.readAsDataURL(imageFile);
                    image_1.onload = function () {
                        var targetSize = _this.compressImage(image_1);
                        canvas_1.width = targetSize.targetWidth;
                        canvas_1.height = targetSize.targetHeight;
                        context_1.drawImage(image_1, 0, 0, targetSize.targetWidth, targetSize.targetHeight);
                        var data = canvas_1.toDataURL(imageFile.type || 'image/png');
                        resolve(data);
                    };
                }
                catch (ex) {
                    reject(ex);
                }
            }
            else {
                resolve(null);
            }
        });
    };
    ImageService.prototype.geetBase64ImageByUrl = function (imgUrl) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (!imgUrl) {
                resolve(null);
            }
            if (_this.isBase64Image(imgUrl)) {
                resolve(imgUrl);
            }
            else {
                var img = document.createElement('img');
                img.crossOrigin = 'anonymous';
                img.onload = function (x) {
                    var base64 = null;
                    try {
                        var image = x.srcElement;
                        base64 = _this.getBase64Image(image);
                        resolve(base64);
                    }
                    catch (e) {
                        reject(e);
                    }
                };
                img.src = _this.imageSourceUrl(imgUrl);
            }
        });
    };
    ImageService.prototype.getBase64Image = function (img, imageType) {
        if (imageType === void 0) { imageType = 'image/png'; }
        var canvas = document.createElement('canvas');
        canvas.width = img.width;
        canvas.height = img.height;
        var ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0);
        var dataURL = canvas.toDataURL(imageType);
        return dataURL;
    };
    ImageService.prototype.isBase64Image = function (url) {
        return url.startsWith('data:');
    };
    ImageService.prototype.getImageFileByBase64 = function (base64) {
        var blob = this.dataURLtoBlob(base64);
        var file = this.blobToFile(blob, 'fileName.jpg');
        return file;
    };
    ImageService.prototype.createImageCropperSetting = function (width, height, isKeepAspect, canvasHeight) {
        if (canvasHeight === void 0) { canvasHeight = 250; }
        var setting = new CropperSettings();
        setting.width = width;
        setting.height = height;
        setting.croppedWidth = width;
        setting.croppedHeight = height;
        setting.canvasWidth = width;
        setting.canvasHeight = canvasHeight;
        setting.preserveSize = true;
        setting.compressRatio = 1;
        setting.keepAspect = isKeepAspect;
        return setting;
    };
    ImageService.prototype.compressImageFile = function (file, width) {
        if (width === void 0) { width = 1200; }
        return __awaiter(this, void 0, void 0, function () {
            var base64, ext, imgFile;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.compressImageFileToBase64(file, width)];
                    case 1:
                        base64 = _a.sent();
                        ext = 'jpg';
                        if (file.name.indexOf('.') >= 0 && file.name.indexOf('.jpg') < 0) {
                            ext = file.name.split('.')[1];
                        }
                        imgFile = this.blobToFile(this.dataURLtoBlob(base64), "image." + ext);
                        return [2 /*return*/, imgFile];
                }
            });
        });
    };
    ImageService.prototype.compressImageFileToBase64 = function (file, width) {
        var _this = this;
        if (width === void 0) { width = 1200; }
        return new Promise(function (resolve, reject) {
            if (!file) {
                reject(null);
            }
            var reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = function (e) {
                var image = new Image();
                image.src = e.target.result;
                image.onload = function () {
                    var canvas = document.createElement('canvas'), context = canvas.getContext('2d'), data = '';
                    var targetSize = _this.compressImage(image, width);
                    canvas.width = targetSize.targetWidth;
                    canvas.height = targetSize.targetHeight;
                    console.log('targetSize', targetSize);
                    context.drawImage(image, 0, 0, targetSize.targetWidth, targetSize.targetHeight);
                    var type = 'image/jpeg', ext = 'jpg';
                    if (file.name.indexOf('.') >= 0 && file.name.indexOf('.jpg') < 0) {
                        ext = file.name.split('.')[1];
                        type = "image/" + ext;
                    }
                    data = canvas.toDataURL(type);
                    resolve(data);
                };
            };
        });
    };
    ImageService.prototype.compressImage = function (image, width) {
        if (width === void 0) { width = 1200; }
        var originWidth = image.naturalWidth, originHeight = image.naturalHeight;
        //let maxWidth = 960, maxHeight = 960;
        var maxWidth = width, maxHeight = width;
        var targetWidth = originWidth, targetHeight = originHeight;
        if (originWidth > maxWidth || originHeight > maxHeight) {
            if (originWidth / originHeight > maxWidth / maxHeight) {
                targetWidth = maxWidth;
                targetHeight = Math.round(maxWidth * (originHeight / originWidth));
            }
            else {
                targetHeight = maxHeight;
                targetWidth = Math.round(maxHeight * (originWidth / originHeight));
            }
        }
        return {
            targetWidth: targetWidth,
            targetHeight: targetHeight,
        };
    };
    ImageService.prototype.dataURLtoBlob = function (imgBase64) {
        var arr = imgBase64.split(','), mime = arr[0].match(/:(.*?);/)[1], bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new Blob([u8arr], { type: mime });
    };
    ImageService.prototype.blobToFile = function (theBlob, fileName) {
        theBlob.lastModifiedDate = new Date();
        theBlob.lastModified = new Date();
        theBlob.name = fileName;
        return theBlob;
    };
    return ImageService;
}());
export { ImageService };



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/services/image.service.ts.pre-build-optimizer.js